module.exports = __webpack_public_path__ + "img/toast.06fd79e9.png";